import { authRoles } from 'app/auth';
import i18next from 'i18next';
import en from './i18n/en';
import hu from './i18n/hu';
import PiAfEventReaderEditForm from './editform/PiAfEventReaderEditForm';
import PiAfEventReaderTable from './table/PiAfEventReaderTable';

i18next.addResourceBundle('en', 'piAfEventReader', en);
i18next.addResourceBundle('hu', 'piAfEventReader', hu);

export default [
	{
		path: '/pi-af-event-reader/edit/:id',
		component: PiAfEventReaderEditForm,
		auth: authRoles.piAfEventReader
	},
	{
		path: '/pi-af-event-reader/:sessionNameParam?',
		component: PiAfEventReaderTable,
		auth: authRoles.piAfEventReader
	}
];
